export interface IAnalyticsDataLayerService{
  pushSafezoneEvent(eventParams:ISafezoneEventParams): void,
  pushSafezoneInitParams(): void
}

export interface ISafezoneDataLayerParams{
  intent: string,
  login_session_id: string,
  user_type: string,
  rm_status: number,
  rg_risk_level: number,
  local_time: string,
  sub_brand_name: number,
  sub_brand_id: number,
  registration_country: string,
  context: string,
  registration_date: string,
  cid: string,
  env: string,
  product_package: number
}

export interface ISafezoneEventParams{
  action: string,
  category: string,
  event: string,
  correlation_id?: string,
  channel: string,
  label: string,
  local_time: string,
  session_status?: SESSION_STATUS
}

export enum SESSION_STATUS {
  Failure = 0,
  Success = 1,
  Partial = 2
};

